import { RmpcNestedDictionaryType } from '@/api/integrations/rmpc/types/types';

const getValuesFromDictionary = (
  dictionaries: RmpcNestedDictionaryType[],
  ids: string[],
  parentKey: string,
  childKey: string,
): Record<string, string[]> => {
  return ids.reduce<Record<string, string[]>>(
    (acc, id) => {
      for (const dictionary of dictionaries) {
        const foundItem = dictionary.items?.find((item) => item.id === id);
        if (foundItem) {
          acc[parentKey].push(dictionary.name);
          acc[childKey].push(foundItem.name);
          break;
        }
      }
      return acc;
    },
    { [parentKey]: [], [childKey]: [] },
  );
};

export const getTypeValuesFromDictionary = (
  categories: RmpcNestedDictionaryType[],
  typeIds: string[],
): { category: string[]; type: string[] } => {
  return getValuesFromDictionary(categories, typeIds, 'category', 'type') as {
    category: string[];
    type: string[];
  };
};

export const getBodyPartValuesFromDictionary = (
  bodyLocations: RmpcNestedDictionaryType[],
  bodyPartIds: string[],
): { body_location: string[]; body_type: string[] } => {
  return getValuesFromDictionary(bodyLocations, bodyPartIds, 'body_location', 'body_type') as {
    body_location: string[];
    body_type: string[];
  };
};
